import React from "react";

const DemographicsTab = () => {
  return <> Demographics </>;
};

export default DemographicsTab;